import { AppLanguage, IEnv } from '@tnq/shared/types';

export const environment: IEnv = {
  production: false,
  apiUrl: 'https://api.test.framna-env-tinqe.cloud/',
  clientId: 'c40d4a1a77d1c2c8609884ffd2bc4783',
  clientSecret:
    'af55843cd637b270016fd541901c665bc6d331a7df2ffadc0c6b9c2a254fcc6a309c263c1915dcb1c7a770e1b421a25829aeb83195cef357031d889b462c9889',
  defaultLang: AppLanguage.Dutch,
  robots: {
    index: false,
    follow: false,
    nosnippet: true,
    noarchive: true,
    nocache: true,
    noimageindex: true,
    nositelinkssearchbox: true,
    googleBot: {
      index: false,
      follow: false,
      noimageindex: true,
      nocache: true,
      noarchive: true,
      nosnippet: true,
      nositelinkssearchbox: true,
    },
  },
};
